export default {
  text: '#dbd1c9',
  primary: '#202020',
  secondary: '#487035',
  background: 'black',
  backgroundSecondary: '#e3e3db',
  light: '#fdfdfd',
  dark: '#202020'
}
